import { ChangeDetectorRef, Component } from '@angular/core';
import { BaseComponent } from '../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { getCurrentTab, Reportv2Tab, Reportv2TabList, Reportv2TabListAgent } from './reportv2.const';
import { NavigationEnd, Router } from '@angular/router';
import { ReportService } from '../../../../common/services/Report.service';
import * as _ from 'lodash';
import { Role } from '../setting/expert/expert.const';

declare const Timer: any;

@Component({
  moduleId: module.id,
  selector: 'reportv2',
  templateUrl: './reportv2.component.html',
  styleUrls: ['./reportv2.component.css'],
})
export class Reportv2Component extends BaseComponent {
  public currentTab = '';
  public tabList = [];
  public readonly Reportv2Tab = Reportv2Tab;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    protected router: Router,
    protected reportService: ReportService
  ) {
    super(changeDetector, toastr, modalService);

    if (this.user.role == Role.Agent) {
      this.tabList = [...Reportv2TabListAgent];
    } else {
      this.tabList = [...Reportv2TabList];
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
        if (this.currentTab == '') {
          this.currentTab = Reportv2Tab.SUMMARY;
        }
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
    this.loadCall().then(() => {});
  }

  onChangeTab(tab: any) {
    this.currentTab = tab;
    this.router.navigate([tab]);
    switch (tab) {
      case Reportv2Tab.SUMMARY:
        // this.loadCall().then();
        break;
    }
  }

  loadCall = async () => {
    //   this.reportService.summaryv3().subscribe(res => {
    // })
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/reportv2.component.ts